import { Warning } from '@mui/icons-material';
import { Alert } from '@mui/material'
import { t } from 'i18next';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateProfile } from "src/_store/entities/profile";
import { Link } from 'react-router-dom';
import { useUpdateMerchantProfileMutation } from 'src/_api/profileAccountApi';

export default function AcceptTermsAndConditionsAlert() {
    const dispatch = useDispatch()
    const { profile } = useSelector((state) => state.entities.profile)

    const [openAlert, setOpenAlert] = useState(false);

    const [updateMerchantProfile] = useUpdateMerchantProfileMutation()

    useEffect(() => {
        const user = profile?.merchant
        if (!!user) {

            if (user?.termsAndConditionsAgreed) {
                setOpenAlert(false)
            } else {
                setOpenAlert(true)
            }
        }

    }, [profile]);

    const closeAlertHandler = async () => {
        setOpenAlert(false)

        let response = await updateMerchantProfile({ termsAndConditionsAgreed: true })
        if (response?.success) {
            if (!!response?.body?.role) {
                dispatch(updateProfile({ ...profile, merchant: response?.body }))
            }
        }

    }

    return (
        <>
            {
                openAlert ?
                    <Alert
                        variant="filled"
                        icon={<Warning />}
                        onClose={closeAlertHandler}
                        sx={{ mb: 1, bgcolor: "#ffbc0d", color: "black", mx: 1 }}
                    >
                        {t("termsAndCondtionsAlert")}&nbsp;
                        <Link style={{ color: "white", textDecoration: "underline" }} to="/terms-and-conditions">{t("Terms and Conditions")}</Link>

                    </Alert> :
                    <></>
            }
        </>
    )
}
